import { useTranslation } from "react-i18next";

const MessageLink = ({row, staticMessage, sendLinkDataFromChild}) => {
    const { t } = useTranslation();
    
    const handleQuantityUpdate = (e, code) => {
        sendLinkDataFromChild(code);
    }

    return (
        <div onClick={(e) => handleQuantityUpdate(e, row.item_code)} className="cursor-pointer relative flex items-center">
            <div className="text-blue-normal text-base font-medium">{staticMessage}</div>
            {staticMessage ? <img className="w-6 h-6" src="../../../../assets/icons/table/tap.png" alt="suggestion" /> : null}
        </div>
    )
}

export default MessageLink;
